import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TagsWidget } from '@/components/widgets/tags-widget/tags-widget';
import { modalState } from '@/state/modal.state';
import { SubHeader } from '@/ui/typography/widgets';
import { Widget } from '@/ui/widget/widget';

import { AppUserEmptyState } from '../../../app-users/empty-state';

import { useTeamTags } from './use-team-tags.query';
import { useSetAtom } from 'jotai';

export const TeamTagsWidget = ({
  teamId,
  defaultHeight,
  disabled,
}: {
  teamId: string;
  defaultHeight: number;
  disabled: boolean;
}) => {
  const { t } = useTranslation('teams');
  const setModal = useSetAtom(modalState);

  const { data } = useTeamTags();

  const onEditClick = useCallback(() => {
    setModal({
      state: 'manageTags',
      type: 'team',
      entityId: teamId,
    });
  }, [setModal, teamId]);

  if (!data?.tags.length) {
    return (
      <Widget
        dataTestId="tags-widget"
        header={<SubHeader>{t`areasOfInterest`}</SubHeader>}
        height={defaultHeight}
        disabled={disabled}
        showEditButton={false}
      >
        <AppUserEmptyState
          onClick={onEditClick}
          buttonText={t`addTags`}
          text={t`emptyTeamTags`}
          variant="secondary"
          disabled={disabled}
        />
      </Widget>
    );
  }

  return (
    <TagsWidget
      testId="tags-widget"
      disabled={disabled}
      onEditClick={onEditClick}
      tags={data.tags}
      subHeader={t`areasOfInterest`}
      widgetHeight={defaultHeight}
    />
  );
};
